import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              爆料专题
            </h2>
            <p className="text-sm text-foreground-500">
              按主题分类浏览，快速找到你感兴趣的吃瓜内容
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {indexItems.map((item) => (
              <a
                key={item.id}
                href="#cards"
                className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 group-hover:bg-primary-100 transition-colors">
                  <i className="ri-folder-line text-xl text-primary-600" />
                </span>
                <div className="text-center">
                  <h3 className="text-sm font-medium text-foreground-800 mb-1 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500">
                    {item.count}
                  </span>
                </div>
                {item.tag && (
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                    item.tag === 'hot'
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-accent-100 text-accent-700'
                  }`}>
                    {item.tag === 'hot' ? '热门' : '最新'}
                  </span>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}